import {
  Operations,
  Resource,
} from "../../bookmydesk-api-sdk-typescript-axios";
import { kLocations } from "./locations";

export const kResources: (Resource & Operations)[] = [
  {
    id: "a1b2c3d4-e5f6-7890-1234-567890abcdef",
    name: "Parking Spot A1",
    description: "Standard parking space near the main entrance.",
    active: true,
    resourceType: "Parking Spot",
    reservationConnectionEnabled: true,
    reservationId: "",
    locationId: kLocations[0].id,
    userId: undefined,
    createdByUserId: undefined,
    dateFrom: "",
    dateTo: "",
    repeatedReservation: true,
    amountAvailable: 12,
    customFields: [],
  },
  {
    id: "4567890a-bcde-f012-4567-890abcdef01234",
    name: "Parking Spot A2",
    description: "",
    active: true,
    resourceType: "Parking Spot",
    reservationConnectionEnabled: true,
    reservationId: "",
    locationId: kLocations[0].id,
    userId: undefined,
    createdByUserId: undefined,
    dateFrom: "",
    dateTo: "",
    repeatedReservation: true,
    amountAvailable: 3,
    customFields: [],
  },
  {
    id: "cdef0123-4567-89ab-cdef-0123456789ab",
    name: "Parking Spot B1",
    description: "Electric vehicle charging available.",
    active: true,
    resourceType: "Parking Spot",
    reservationConnectionEnabled: true,
    reservationId: "",
    locationId: kLocations[0].id,
    userId: undefined,
    createdByUserId: undefined,
    dateFrom: "",
    dateTo: "",
    repeatedReservation: true,
    amountAvailable: 18,
    customFields: [
      {
        name: "Charging Type",
        description: "Type 2",
      },
    ],
  },
  {
    id: "ef012345-6789-abcd-ef01-23456789abcd",
    name: "Parking Spot C1",
    description: "Accessible parking space.",
    active: true,
    resourceType: "Parking Spot",
    reservationConnectionEnabled: true,
    reservationId: "",
    locationId: kLocations[0].id,
    userId: undefined,
    createdByUserId: undefined,
    dateFrom: "",
    dateTo: "",
    repeatedReservation: true,
    amountAvailable: 5,
    customFields: [
      {
        name: "Accessibility Features",
        description: "Wider space, ramp access nearby",
      },
    ],
  },
  {
    id: "f0e9d8c7-b6a5-4321-fedc-ba9876543210",
    name: "Parking Spot D1",
    description: "Located in the visitor parking area.",
    active: true,
    resourceType: "Parking Spot",
    reservationConnectionEnabled: true,
    reservationId: "",
    locationId: kLocations[0].id,
    userId: undefined,
    createdByUserId: undefined,
    dateFrom: "",
    dateTo: "",
    repeatedReservation: true,
    amountAvailable: 3,
    customFields: [],
  },
  {
    id: "23456789-0abc-def1-2345-67890abcdef012",
    name: "Parking Spot E1",
    description: "Near the loading dock.",
    active: true,
    resourceType: "Parking Spot",
    reservationConnectionEnabled: true,
    reservationId: "",
    locationId: kLocations[0].id,
    userId: undefined,
    createdByUserId: undefined,
    dateFrom: "",
    dateTo: "",
    repeatedReservation: true,
    amountAvailable: 1,
    customFields: [],
  },
];
